module.exports = jsyaml;


//////////////////
// WEBPACK FOOTER
// external "jsyaml"
// module id = 18
// module chunks = 1